/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportCostsByEmploymentTypeRollup
 */
export interface ReportCostsByEmploymentTypeRollup {
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByEmploymentTypeRollup
     */
    employees: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByEmploymentTypeRollup
     */
    shifts: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByEmploymentTypeRollup
     */
    hoursScheduled: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByEmploymentTypeRollup
     */
    hoursWorked: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByEmploymentTypeRollup
     */
    costsScheduled: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByEmploymentTypeRollup
     */
    costsWorked: number;
}

/**
 * Check if a given object implements the ReportCostsByEmploymentTypeRollup interface.
 */
export function instanceOfReportCostsByEmploymentTypeRollup(value: object): value is ReportCostsByEmploymentTypeRollup {
    if (!('employees' in value) || value['employees'] === undefined) return false;
    if (!('shifts' in value) || value['shifts'] === undefined) return false;
    if (!('hoursScheduled' in value) || value['hoursScheduled'] === undefined) return false;
    if (!('hoursWorked' in value) || value['hoursWorked'] === undefined) return false;
    if (!('costsScheduled' in value) || value['costsScheduled'] === undefined) return false;
    if (!('costsWorked' in value) || value['costsWorked'] === undefined) return false;
    return true;
}

export function ReportCostsByEmploymentTypeRollupFromJSON(json: any): ReportCostsByEmploymentTypeRollup {
    return ReportCostsByEmploymentTypeRollupFromJSONTyped(json, false);
}

export function ReportCostsByEmploymentTypeRollupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportCostsByEmploymentTypeRollup {
    if (json == null) {
        return json;
    }
    return {
        
        'employees': json['employees'],
        'shifts': json['shifts'],
        'hoursScheduled': json['hoursScheduled'],
        'hoursWorked': json['hoursWorked'],
        'costsScheduled': json['costsScheduled'],
        'costsWorked': json['costsWorked'],
    };
}

  export function ReportCostsByEmploymentTypeRollupToJSON(json: any): ReportCostsByEmploymentTypeRollup {
      return ReportCostsByEmploymentTypeRollupToJSONTyped(json, false);
  }

  export function ReportCostsByEmploymentTypeRollupToJSONTyped(value?: ReportCostsByEmploymentTypeRollup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employees': value['employees'],
        'shifts': value['shifts'],
        'hoursScheduled': value['hoursScheduled'],
        'hoursWorked': value['hoursWorked'],
        'costsScheduled': value['costsScheduled'],
        'costsWorked': value['costsWorked'],
    };
}

